import React, {useEffect, useState} from 'react';
import {getQrtList, getQstList, postQstOrder} from '../resources/services/frontController'
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";
import SpinnerHexagone from "../components/SpinnerHexagone";
import {Fab} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    form: {
        width: '100%',
    },

}));

export default function Ordre(props) {

    const classes = useStyles();
    const [listeQrt, setListeQrt] = useState([]);
    const [listeQst, setListeQst] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [orderList, setOrderList] = React.useState();

    useEffect(() => {
        Promise.all([
            getQrtList(), getQstList()
        ]).then(responses => {
            setListeQrt(responses[0].data);
            setListeQst(responses[1].data);
            responses[1].data.map(
                qst => setOrderList(orderList => ({...orderList, [qst.qstId]: qst.qstOrdre})));
            setIsLoading(false);
        })
    }, []);

    function postOrder() {
        postQstOrder(orderList)
            .then(response => {
                getQstList().then(response => {
                    const data = response.data;
                    setListeQst(data);
                });
            });
    }

    function changeQstOrder(event, id) {
        var ordre = event.target.value;
        setOrderList(orderList => ({...orderList, [id]: ordre}));
    }

    return (
        <SpinnerHexagone isLoading={isLoading}>
            {listeQrt.map(qrtRow => {
                if (orderList) {
                    return (
                        <Paper style={{marginTop: '15px', minHeight: '150px'}}>
                            <h3 style={{textAlign: 'center'}}>{qrtRow.qrtLibelle}</h3>
                            <Table size="small">
                                <TableHead>
                                    <TableRow className="text-center">
                                        <TableCell component="td" scope="row">ID</TableCell>
                                        <TableCell component="td" scope="row">Texte de la question</TableCell>
                                        <TableCell component="td" scope="row">Questionnaire</TableCell>
                                        <TableCell component="td" scope="row">Type de question</TableCell>
                                        <TableCell component="td" scope="row">Question mère</TableCell>
                                        <TableCell component="td" scope="row">Ordre</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {listeQst.map(qstRow => {
                                            if (qrtRow.qrtId === qstRow.qrt.qrtId) {
                                                return (
                                                    <TableRow key={qstRow.qstId}>
                                                        <TableCell component="td" scope="row">
                                                            <IconButton align="left">{qstRow.qstId}</IconButton>
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            <IconButton align="left">{qstRow.qstTxt}</IconButton>
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            <IconButton align="left">{qstRow.qrt.qrtLibelle}</IconButton>
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            <IconButton align="left">{qstRow.tpe.tpeLibelle}</IconButton>
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            <IconButton align="left">{qstRow.qstMere}</IconButton>
                                                        </TableCell>
                                                        <TableCell component="td" scope="row">
                                                            <TextField
                                                                id={'qst_ordre' + qstRow.qstId}
                                                                label="Position"
                                                                type="number"
                                                                name={'qst_ordre' + qstRow.qstId}
                                                                onChange={(e) => changeQstOrder(e, qstRow.qstId)}
                                                                value={orderList[qstRow.qstId]}
                                                                fullWidth
                                                            >
                                                            </TextField>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        }
                                    )
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                    )
                }
            })
            }
            <div style={{width:'100%',textAlign:'center'}}>
                <Fab variant="extended" type="submit" size="small" color="primary" aria-label="Add"
                     style={{margin: '2% 0'}}
                     onClick={(e) => postOrder()}>Valider l'ordre des questionnaires</Fab>
            </div>
        </SpinnerHexagone>
    )
}